// extracted by mini-css-extract-plugin
export default {"StateLabel":"HeaderState-module__StateLabel--T9zBK"};